import { cn } from '@heidi/utils';
import type { CSSProperties, ReactNode } from 'react';

/**
 * Same mask + `ptb-text-shimmer` sweep as the app's `OverlayShimmerText`.
 * The keyframe is global; this only applies the mask.
 */
const SHIMMER_MASK =
  'linear-gradient(90deg, #000 0%, #000 35%, rgba(0,0,0,0.35) 50%, #000 65%, #000 100%)';

const SHIMMER_STYLE: CSSProperties = {
  maskImage: SHIMMER_MASK,
  maskSize: '200% 100%',
  WebkitMaskImage: SHIMMER_MASK,
  WebkitMaskSize: '200% 100%',
  animation: 'ptb-text-shimmer 2s ease-in-out infinite',
};

export const ShimmerText = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element => (
  <span className={cn('inline-block', className)} style={SHIMMER_STYLE}>
    {children}
  </span>
);
